import React, { Component } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Flex, Box } from '@rebass/grid';
import Icon from '@ro-atoms/Icon';
import RoDivider from '@ro-atoms/RoDivider';
import { TextWrapper, RemoveIcon, Text, IconWrapper, MenuItemWrapper } from './RoDropdownItem.styles';

class RoDropdownItem extends Component {
  static defaultProps = {
    innerWidth: '100%',
    leftIcon: 'map-marker-alt',
    removeable: true
  };
  state = {
    isHovered: false
  };
  setHoverFlag = isHovered => this.setState({ isHovered });
  render() {
    const { item, innerWidth, leftIcon, onRemove, onMenuItemClick, divider } = this.props;

    return (
      <MenuItemWrapper divider={divider}>
        <MenuItem onClick={() => onMenuItemClick(item)}>
          <Flex width={innerWidth} alignItems={'center'}>
            {leftIcon && (
              <Box px={10}>
                <Icon name={`${leftIcon} fas`} />
              </Box>
            )}
            <TextWrapper px={0} flex={'1 1 100%'}>
              <Text noWrap>{item.name}</Text>
            </TextWrapper>
          </Flex>
        </MenuItem>

        {onRemove && (
          <IconWrapper className={'ro-dropdown-remove-icon'} onClick={() => onRemove(item)} px={15}>
            <RemoveIcon />
          </IconWrapper>
        )}
        {divider ? <RoDivider /> : null}
      </MenuItemWrapper>
    );
  }
}

export default RoDropdownItem;
